import { adminSearchShardCatalogDetailsDefaultGetSlice } from './get';
import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

export const adminSearchShardCatalogDetailsDefaultReducers = combineReducers({
	get: adminSearchShardCatalogDetailsDefaultGetSlice.asyncReducers
});

export const adminSearchShardCatalogDetailsDefaultWatchers = combineAllWatchers([
	adminSearchShardCatalogDetailsDefaultGetSlice.asyncWatchers
]);
